import React from 'react';
import { Button, Col, Form, FormGroup, Input, Label, Row } from 'reactstrap';

interface NewHireStepFourProps {
  handleSubmitForm: (e: React.FormEvent<HTMLFormElement>) => void;
  isAddToPayroll: boolean | null | undefined;
  setIsAddToPayroll: (value: boolean) => void;
  isCollectTaxInformation: boolean | null | undefined;
  setIsCollectTaxInformation: (value: boolean) => void;
  setNewEmployeeFormStep: (step: number) => void;
}

const NewHireStepFour: React.FC<NewHireStepFourProps> = ({
  handleSubmitForm,
  isAddToPayroll,
  setIsAddToPayroll,
  isCollectTaxInformation,
  setIsCollectTaxInformation,
  setNewEmployeeFormStep,
}) => {
  return (
    <Form onSubmit={handleSubmitForm}>
      <Row className="d-flex align-items-center mt-4">
        <Col lg="3">
          <Label className="form-control-label">Add to Payroll:</Label>
        </Col>
        <Col lg="9">
          <div className="d-flex flex-wrap">
            {' '}
            <FormGroup check inline className="mr-3">
              <Label check htmlFor="payroll-yes">
                <Input
                  className="form-check-input"
                  type="radio"
                  name="payroll-radio"
                  id="payroll-yes"
                  checked={isAddToPayroll === true}
                  onChange={() => setIsAddToPayroll(true)}
                  required
                />
                Yes
              </Label>
            </FormGroup>
            <FormGroup check inline className="mr-3">
              <Label check htmlFor="payroll-no">
                <Input
                  className="form-check-input"
                  type="radio"
                  name="payroll-radio"
                  id="payroll-no"
                  checked={isAddToPayroll === false}
                  onChange={() => setIsAddToPayroll(false)}
                  required
                />
                No
              </Label>
            </FormGroup>
          </div>
        </Col>
      </Row>

      <Row className="d-flex align-items-center mt-4">
        <Col lg="3">
          <Label className="form-control-label">Collect Tax Information:</Label>
        </Col>
        <Col lg="9">
          <div className="d-flex flex-wrap">
            {' '}
            <FormGroup check inline className="mr-3">
              <Label check htmlFor="collect-tax-information-yes">
                <Input
                  className="form-check-input"
                  type="radio"
                  name="collect-tax-information-radio"
                  id="collect-tax-information-yes"
                  checked={isCollectTaxInformation === true}
                  onChange={() => setIsCollectTaxInformation(true)}
                  required
                />
                Yes
              </Label>
            </FormGroup>
            <FormGroup check inline className="mr-3">
              <Label check htmlFor="collect-tax-information-no">
                <Input
                  className="form-check-input"
                  type="radio"
                  name="collect-tax-information-radio"
                  id="collect-tax-information-no"
                  checked={isCollectTaxInformation === false}
                  onChange={() => setIsCollectTaxInformation(false)}
                  required
                />
                No
              </Label>
            </FormGroup>
          </div>
        </Col>
      </Row>

      <hr />

      <div className="d-flex justify-content-end mt-4">
        <div>
          <Button className="btn-secondary mr-2" onClick={() => setNewEmployeeFormStep(3)}>
            Back
          </Button>
          <Button color="warning" type="submit">
            Continue
          </Button>
        </div>
      </div>
    </Form>
  );
};

export default NewHireStepFour;
